(function () {
  var started = false;

  var utmKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
  ];

  function getWidgets() {
    return document.querySelectorAll('.calendly-inline-widget');
  }

  function applyStoredUtms() {
    getWidgets().forEach(function (widget) {
      var originalUrl = widget.getAttribute('data-url');

      if (!originalUrl) {
        return;
      }

      var calendlyUrl = new URL(originalUrl);

      utmKeys.forEach(function (key) {
        var value = sessionStorage.getItem('marketing_' + key);

        if (value) {
          calendlyUrl.searchParams.set(key, value);
        }
      });

      widget.setAttribute('data-url', calendlyUrl.toString());
    });
  }

  function loadCalendly() {
    if (document.querySelector(
      'script[data-calendly-widget-script="true"]'
    )) {
      return;
    }

    var script = document.createElement('script');

    script.src =
      'https://assets.calendly.com/assets/external/widget.js';

    script.async = true;
    script.setAttribute('data-calendly-widget-script', 'true');

    document.head.appendChild(script);
  }

  function initialise() {
    if (started) {
      return;
    }

    var widgets = getWidgets();

    if (!widgets.length) {
      return;
    }

    started = true;
    applyStoredUtms();
    loadCalendly();
  }

  function waitForWidgets() {
    initialise();

    if (started) {
      return;
    }

    var observer = new MutationObserver(function () {
      initialise();

      if (started) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForWidgets);
  } else {
    waitForWidgets();
  }
})();